// .u_filtered-list-item
class UFilteredListItem extends Uneet {
  constructor (domElement, data = null, isUpcoming) {
    super(domElement)
    // copy all attributes from the incoming data
    if (data !== null) {
      // data.assign(this)
      Object.assign(this, data)
    }
    this.isUpcoming = isUpcoming
    this.isHovered = false
    this.__init()
  }

  __init () {
    this._e.removeClass('isTemplate')
    if (this.isUpcoming) {
      this._e.addClass('isUpcoming')
    }
    this.__fill()
    // bind hover effects
    this._e.querySelectorAll('a.image-container, h5.title > a').forEach((anchor) => {
      anchor.onHover(() => { this.toggleHover(true) }, () => { this.toggleHover(false) })
    })
  }

  __fill () {
    // fill all the data into the DOM element
    this._e.setAttribute('id', this.idprefix + this.item_id)
    this._e.querySelectorAll('a.image-container')[0].setAttribute('href', this.url)
    this._e.querySelectorAll('h5.title > a')[0].setAttribute('href', this.url)
    this._e.querySelectorAll('h5.title > a')[0].innerHTML = this.title
    this._e.querySelectorAll('div.image')[0].setAttribute('style', 'background-image:url(\'' + this.featured_image + '\');')
    this._e.querySelectorAll('img.img-tag')[0].setAttribute('src', this.featured_image)
    this._e.querySelectorAll('span.month')[0].innerHTML = this.date.month
    this._e.querySelectorAll('span.month-short')[0].innerHTML = this.date.month.substring(0, 3)
    let theDay = parseInt(this.date.day)
    if (this.isUpcoming) {
      theDay = (theDay < 10) ? '0' + theDay.toString() : theDay.toString()
    }
    this._e.querySelectorAll('span.day')[0].innerHTML = theDay
    this._e.querySelectorAll('span.day-of-week')[0].innerHTML = this.date.day_of_week.substring(0, 3)
    this._e.querySelectorAll('span.year')[0].innerHTML = this.date.year
    this._e.querySelectorAll('span.start-time')[0].innerHTML = this.start_time
    this._e.querySelectorAll('span.end-time')[0].innerHTML = this.end_time
    if (this.location) {
      this._e.querySelectorAll('div.location span')[0].innerHTML = this.location
    } else {
      const removeThis = this._e.querySelectorAll('div.location')[0]
      removeThis.parentNode.removeChild(removeThis)
    }
    if ((this.event_type) || (this.event_admission)) {
      const eventTypeDOM = this._e.querySelectorAll('span.event-type')[0]
      const eventAdmDOM = this._e.querySelectorAll('span.admission')[0]
      if (this.event_type) {
        eventTypeDOM.innerHTML = this.event_type.name
      } else {
        eventTypeDOM.parentNode.removeChild(eventTypeDOM)
      }
      if (this.event_admission) {
        eventAdmDOM.innerHTML = this.event_admission.name
        if (this.event_admission.name.toUpperCase().replace(/\s+/g, '') === 'MEMBERSONLY') {
          this._e.addClass('isMembersOnly')
        }
      } else {
        eventAdmDOM.parentNode.removeChild(eventAdmDOM)
      }
    } else {
      const eventData = this._e.querySelectorAll('div.event-data')[0]
      eventData.parentNode.removeChild(eventData)
    }
  }

  toggleHover (force = null) {
    if (force === null) {
      this.isHovered = !this.isHovered
    } else {
      this.isHovered = force
    }

    this._e.toggleClass('isHovered', this.isHovered)
  }

  delete () {
    // delete from DOM
    this._e.parentNode.remove(this._e)
  }
}
